interface RowProps {
  label: string;
  value: string;
}

export default function Row({ label, value }: RowProps) {
  return (
    <dl className="sm:flex items-center justify-between gap-4">
      <dt className="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">{label}</dt>
      <dd className="font-medium text-gray-900 dark:text-white sm:text-end">{value}</dd>
    </dl>
  );
}
